import { Box, Table, Text } from '@chakra-ui/react';
import type React from 'react';
import { FaceliftScrollContainer } from '@/components/Atoms/FaceliftScrollContainer';
import Show from '@/components/Molecules/Show';
import { useGetClaims } from '@/hooks/service-hooks/patients';

interface ClaimsViewProps {
  id: string;
}

const ClaimsView: React.FC<ClaimsViewProps> = ({
  id,
}) => {

  const { data: rows = [], isFetching: isLoading } = useGetClaims(id, !!id);
  return (
    <FaceliftScrollContainer overflowY="auto" minWidth="fit-content" height="calc(100% - 500px)">
      <Show when={isLoading}>
        <Box>loading...</Box>
      </Show>
      <Show when={rows && rows.length > 0 && !isLoading}>
        <Table.Root size="sm" variant="outline">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader borderWidth="1px 2px 1px 1px" width="110px" textAlign="center" fontWeight="bold">Order#</Table.ColumnHeader>
              <Table.ColumnHeader borderWidth="1px" px={6} fontWeight="bold">Physician name</Table.ColumnHeader>
              <Table.ColumnHeader borderWidth="1px" width="110px" textAlign="center" fontWeight="bold">QTY</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows.map((row, idx) =>
              row.orders.map((order, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell borderWidth="1px 2px 1px 1px" textAlign="center">{order.ta_name}</Table.Cell>
                  <Table.Cell borderWidth="1px" px={6}>{order.physician.fullname || '-'}</Table.Cell>
                  <Table.Cell borderWidth="1px" textAlign="center">{order.ta_units || '-'}</Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table.Root>
      </Show>

      <Show when={(!rows || rows.length === 0) && !isLoading}>
        <Box textAlign="center" py={8}>
          <Text fontSize="md" color="gray.500">
            No orders found
          </Text>
        </Box>
      </Show>
    </FaceliftScrollContainer>
  );
};

export default ClaimsView;


